var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 6.1C23.2 5.9 22.8 6 22.5 6.2L17 10.1V7C17 5.3 15.7 4 14 4H3C1.3 4 0 5.3 0 7V17C0 18.7 1.3 20 3 20H14C15.7 20 17 18.7 17 17V13.9L22.4 17.8C22.6 17.9 22.8 18 23 18C23.2 18 23.3 18 23.5 17.9C23.8 17.7 24 17.4 24 17V7C24 6.6 23.8 6.3 23.5 6.1ZM15 17C15 17.6 14.6 18 14 18H3C2.4 18 2 17.6 2 17V7C2 6.4 2.4 6 3 6H14C14.6 6 15 6.4 15 7V17ZM17.7 12L22 15.1V8.9L17.7 12Z",
    fill: "#212529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5748_4943",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 24,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 6.1C23.2 5.9 22.8 6 22.5 6.2L17 10.1V7C17 5.3 15.7 4 14 4H3C1.3 4 0 5.3 0 7V17C0 18.7 1.3 20 3 20H14C15.7 20 17 18.7 17 17V13.9L22.4 17.8C22.6 17.9 22.8 18 23 18C23.2 18 23.3 18 23.5 17.9C23.8 17.7 24 17.4 24 17V7C24 6.6 23.8 6.3 23.5 6.1ZM15 17C15 17.6 14.6 18 14 18H3C2.4 18 2 17.6 2 17V7C2 6.4 2.4 6 3 6H14C14.6 6 15 6.4 15 7V17ZM17.7 12L22 15.1V8.9L17.7 12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5748_4943)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H24V24H0V0Z",
    fill: "#212529"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCam);
export default __webpack_public_path__ + "static/media/ic_cam.34d71115583fe52c9821b6fd78a9bf08.svg";
export { ForwardRef as ReactComponent };